import { UserMessage } from '../../../../types/UserMessage';
import { Text } from '../../../cdl/Text/Text';
import { VerticalDetail } from '../../../common/Detail/VerticalDetail';
import { formatDateTime } from '../../../common/helpers/formatDateTime.helper';
import { formatNumber } from '../../../common/helpers/formatNumber.helper';
import { translate } from '../../../common/helpers/translate.helper';
import { Characters } from '../../../common/helpers/unicode.helper';
import { InfoPopover } from '../../../common/InfoPopover/InfoPopover';
import { Box } from '../../../common/ui/Box';

interface ActivitySectionProps {
    user: UserMessage;
}

export const ActivitySection = ({ user }: ActivitySectionProps) => {
    return (
        <Box display="flex" flexDirection="column" gap={16}>
            <Text variant="title" as="h2">
                {translate('user.activity.title')}
            </Text>
            <Box display="grid" gap={16}>
                <Box display="grid">
                    <Box display="flex" alignItems="center" gap={6}>
                        <Text fontWeight={600}>{translate('user.dateLastLogin')}</Text>
                        <InfoPopover width="250px">
                            <Text variant="extraSmall">{translate('user.loginStats.info')}</Text>
                        </InfoPopover>
                    </Box>
                    <Box maxWidth="fit-content">
                        <Text>
                            {user.dateLastLogin ? formatDateTime({ date: user.dateLastLogin }) : Characters.EN_DASH}
                        </Text>
                    </Box>
                </Box>
                <VerticalDetail
                    label={translate('user.loginTimes')}
                    value={
                        user.loginTimes !== undefined
                            ? formatNumber({
                                  number: user.loginTimes,
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                              })
                            : Characters.EN_DASH
                    }
                />
                <VerticalDetail
                    label={translate('user.dateUpdated')}
                    value={formatDateTime({ date: user.dateUpdated })}
                />
                <VerticalDetail
                    label={translate('user.dateCreated')}
                    value={formatDateTime({ date: user.dateCreated })}
                />
            </Box>
        </Box>
    );
};
